import React from 'react'
import './css/services.css'

export default function Main_Heading(props) {
  return (
    <>
      <div className="container Award">
            <div className="row row-cols-2 section-award">
                <div className="col heading-section">
                    <div className="heading-content">
                        <h1>
                        {props.SideHeading}
                        </h1>
                    </div>
                    <div className="heading-button">
                        <div className="button-design">
                            <h4>{props.ButtonText}</h4>
                        </div>
                    </div>
                </div>

                    <div className="col side-section">
                    <div className="side-contain">
                        
                        <div className="side-para1">
                        <p>{props.para1}</p>
                        </div>
                        <div className="side-para1">
                        <p>{props.para2}</p>
                        </div>
                        <div className="side-para1">
                        <p>{props.para3}</p>
                        <p>{props.para4}</p>
                        <p>{props.para5}</p>
                        <p>{props.para6}</p>
                        <p>{props.para7}</p>
                        </div>

                        
                        
                        
                    </div>

                    </div>

                    </div>

            </div>
            
       
    </>
  )
}
